function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children", "active"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { autoUpdate, flip, FloatingFocusManager, FloatingPortal, size, useDismiss, useFloating, useId, useInteractions, useListNavigation, useRole } from '@floating-ui/react';
import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { Input } from "../Input";
import { cn } from "../lib/utils";
var Item = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    active = _ref.active,
    rest = _objectWithoutProperties(_ref, _excluded);
  var id = useId();
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    role: "option",
    id: id,
    "aria-selected": active
  }, rest, {
    className: cn('text-xs text-gray-900 cursor-pointer px-[14px] py-[10px] focus:bg-accent hover:bg-gray-50 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50', active ? 'bg-accent' : '')
  }), children);
});
export function AutoComplete(_ref2) {
  var options = _ref2.options,
    onSearch = _ref2.onSearch,
    filterOption = _ref2.filterOption,
    value = _ref2.value,
    onChange = _ref2.onChange,
    className = _ref2.className,
    placeholder = _ref2.placeholder,
    root = _ref2.root,
    containerClassName = _ref2.containerClassName,
    inputProps = _ref2.inputProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(value || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    activeIndex = _useState6[0],
    setActiveIndex = _useState6[1];
  var listRef = useRef([]);
  var _useFloating = useFloating({
      whileElementsMounted: autoUpdate,
      open: open,
      onOpenChange: setOpen,
      middleware: [flip({
        padding: 10
      }), size({
        apply: function apply(_ref3) {
          var rects = _ref3.rects,
            availableHeight = _ref3.availableHeight,
            elements = _ref3.elements;
          Object.assign(elements.floating.style, {
            width: "".concat(rects.reference.width, "px"),
            maxHeight: "".concat(availableHeight, "px")
          });
        },
        padding: 10
      })]
    }),
    refs = _useFloating.refs,
    floatingStyles = _useFloating.floatingStyles,
    context = _useFloating.context;
  var role = useRole(context, {
    role: 'listbox'
  });
  var dismiss = useDismiss(context);
  var listNav = useListNavigation(context, {
    listRef: listRef,
    activeIndex: activeIndex,
    onNavigate: setActiveIndex,
    virtual: true,
    loop: true
  });
  var _useInteractions = useInteractions([role, dismiss, listNav]),
    getReferenceProps = _useInteractions.getReferenceProps,
    getFloatingProps = _useInteractions.getFloatingProps,
    getItemProps = _useInteractions.getItemProps;
  function onSearchChange(event) {
    var v = event.target.value;
    setSearchValue(v);
    if (v) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(v);
      setOpen(true);
      setActiveIndex(0);
    } else {
      setOpen(false);
    }
  }
  var handleFocus = function handleFocus() {
    if (!onSearch) {
      setOpen(true);
    }
  };
  var items = options.filter(function (item) {
    return filterOption ? filterOption(searchValue, item) : true;
  });
  useEffect(function () {
    if (value && !activeIndex) {
      setActiveIndex(items.findIndex(function (it) {
        return it.value === value;
      }));
    }
  }, [value, activeIndex]);
  var current = useMemo(function () {
    return items.find(function (it) {
      return it.value === value;
    });
  }, [value, items]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, getReferenceProps(_objectSpread({
    ref: refs.setReference,
    className: className,
    onChange: onSearchChange,
    onClick: handleFocus,
    value: searchValue,
    placeholder: placeholder,
    'aria-autocomplete': 'list',
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter' && activeIndex && items[activeIndex]) {
        onChange === null || onChange === void 0 ? void 0 : onChange(items[activeIndex].value);
        setActiveIndex(null);
        setOpen(false);
      }
    }
  }, inputProps))), /*#__PURE__*/React.createElement(FloatingPortal, {
    root: root
  }, open && /*#__PURE__*/React.createElement(FloatingFocusManager, {
    context: context,
    initialFocus: -1,
    visuallyHiddenDismiss: true
  }, /*#__PURE__*/React.createElement("div", getFloatingProps({
    ref: refs.setFloating,
    style: _objectSpread({}, floatingStyles),
    className: cn('bg-popover overflow-y-auto shadow-md border rounded-md z-10', containerClassName)
  }), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: item.value
    }, getItemProps({
      key: item.value,
      ref: function ref(node) {
        listRef.current[index] = node;
      },
      onClick: function onClick() {
        var _refs$domReference$cu;
        onChange === null || onChange === void 0 ? void 0 : onChange(item.value);
        setSearchValue(item.value);
        setOpen(false);
        (_refs$domReference$cu = refs.domReference.current) === null || _refs$domReference$cu === void 0 ? void 0 : _refs$domReference$cu.focus();
      }
    }), {
      active: (current === null || current === void 0 ? void 0 : current.value) === item.value
    }), item.label);
  })))));
}